import { __extends, __awaiter, __generator, __assign, __decorate, __metadata } from 'tslib';
import { MagicConfigMixin } from '@gig/magic-common';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { UPDATE_USER_STATUS, USER_PROFILE_DATA } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { initScanVerificationPolling, launchScanVerification } from '@gig/magic-corex';

var SweepstakesSsn = /** @class */ (function (_super) {
    __extends(SweepstakesSsn, _super);
    function SweepstakesSsn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.codeLength = 4;
        _this.taxId = '';
        _this.ssnLoading = false;
        _this.showSsnError = false;
        _this.scanLoading = false;
        _this.scanDisabled = false;
        return _this;
    }
    SweepstakesSsn.prototype.onSsnUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var profile, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.$v.taxId.$invalid) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        this.ssnLoading = true;
                        return [4 /*yield*/, this.getProfile()];
                    case 2:
                        profile = _b.sent();
                        return [4 /*yield*/, magic.methods.users.updateUserProfile(__assign(__assign({}, profile), { user: __assign(__assign({}, profile.user), { taxId: this.taxId }) }))];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, window.commandBus.publish(UPDATE_USER_STATUS)];
                    case 4:
                        _b.sent();
                        this.showSsnError = false;
                        this.$emit('ssn-update');
                        return [3 /*break*/, 7];
                    case 5:
                        _a = _b.sent();
                        this.showSsnError = true;
                        return [3 /*break*/, 7];
                    case 6:
                        this.ssnLoading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesSsn.prototype.onScanClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.scanDisabled) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        this.scanLoading = true;
                        return [4 /*yield*/, launchScanVerification()];
                    case 2:
                        url = (_a.sent()) || null;
                        this.scanLoading = false;
                        this.scanDisabled = true;
                        return [4 /*yield*/, initScanVerificationPolling(url)];
                    case 3:
                        _a.sent();
                        this.scanDisabled = false;
                        this.$emit('ssn-update');
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.scanLoading = false;
                        this.scanDisabled = false;
                        this.$emit('ssn-error');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesSsn.prototype.getProfile = function () {
        return window.queryBus.query(USER_PROFILE_DATA);
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SweepstakesSsn.prototype, "showScan", void 0);
    SweepstakesSsn = __decorate([
        Component({
            name: 'sweepstakes-ssn',
            validations: function () {
                var rules = {};
                rules.taxId = {
                    required: required,
                    minLength: minLength(this.codeLength),
                };
                return rules;
            },
        })
    ], SweepstakesSsn);
    return SweepstakesSsn;
}(Mixins(validationMixin, MagicConfigMixin)));

export default SweepstakesSsn;
